import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { AdminService } from '../services/admin.service';

export const resetPasswordGuard: CanActivateFn = async (route, { url }) => {
  const authService = inject(AuthService);
  const adminService = inject(AdminService);
  const router = inject(Router);
  const accessToken = route.queryParamMap.get('params');
  const service = url.includes('/admin') ? adminService : authService

  if (!accessToken) {
    router.navigate(['/not-found']);
    return false;
  }

  try {
    const validToken = await service.verifyToken({ accessToken, tokenType: 'PasswordReset' });
    return validToken;
  } catch (err) {
    console.error(err);
    router.navigate(['/not-found']);
    return false;
  }
};
